module.exports = __webpack_public_path__ + "media/images/captive_portal/Upload-btn-d680ffe13dd1abe46c7377f2af2cf333.svg";